import PageContainer from './PageContainer';

const NotFoundPage = () => {
  return (
    <PageContainer>
      <h1>Page Not Found</h1>
    </PageContainer>
  );
};

export default NotFoundPage;
